import { Link } from "react-router-dom";

import arrowIcon from "assets/icons/svg/AboutUsIcons/arrowup.svg";
import cloudIcon from "assets/icons/svg/AboutUsIcons/cloud.svg";

import "./style.scss";

const AbousUsJoinUs = () => {
	const para =
		"We strive for our entire team to have top-notch work experiences that inspire and motivate next-level career growth. (We also have a lot of fun along the way!) Want to join the SaffronStays family? We can’t wait to hear from you!";

	return (
		<div className="join_us_wrapper">
			<div className="join_left">
				<div className="left_text">
					Come, work with us.<br></br> We’re hiring!
				</div>
			</div>
			<div className="join_right">
				<div className="para">{para}</div>
				<Link
					aria-label="join-us"
					to="/join-us"
					style={{ textDecoration: "none" }}
				>
					<div className="join_button">Join us!</div>
				</Link>
			</div>
			<img className="arrowIcon2" src={arrowIcon} alt="arrowIcon2" />
			<img className="cloudIcon1" src={cloudIcon} alt="cloudIcon1" />
			<img className="cloudIcon2" src={cloudIcon} alt="cloudIcon2" />
			<img className="cloudIcon3" src={cloudIcon} alt="cloudIcon3" />
		</div>
	);
};

export default AbousUsJoinUs;
